var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 612.02 612.02",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M596.96 269.674 342.381 15.094c-20.079-20.079-52.644-20.079-72.723 0s-20.079 52.644 0 72.723L487.852 306.01 269.658 524.202c-20.079 20.079-20.079 52.644 0 72.723s52.644 20.079 72.723 0L596.96 342.346c20.079-20.029 20.079-52.593 0-72.672zm-306.102-15.416L88.744 41.238c-20.309-21.378-53.204-21.378-73.513 0s-20.309 56.058 0 77.462l165.371 174.289L15.231 467.278c-20.309 21.379-20.309 56.083 0 77.462s53.204 21.379 73.513 0l202.114-213.02c20.309-21.378 20.309-56.058 0-77.462z",
    fill: "#3c0000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.8cf0004a4c116f74ed2d7c667dbda2df.svg";
export { ForwardRef as ReactComponent };